import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollUpdateSavedCustomFieldViewInput,
  PayrollUpdateSavedCustomFieldViewResponse,
} from '../types';

type PayrollUpdateSavedCustomFieldViewRequest = {
  input: PayrollUpdateSavedCustomFieldViewInput;
};

export const updateSavedCustomFieldViewMutation = gql`
  mutation PayrollUpdateSavedCustomFieldView($input: PayrollUpdateSavedCustomFieldViewInput!) {
    payrollUpdateSavedCustomFieldView(input: $input) {
      viewType
      fieldKeys
      updatedBy
      updatedAt
    }
  }
`;

export const updateSavedCustomFieldView = (
  queryVariables: PayrollUpdateSavedCustomFieldViewRequest,
) =>
  graphQLApi<
    PayrollUpdateSavedCustomFieldViewResponse,
    PayrollUpdateSavedCustomFieldViewRequest
  >({
    query: updateSavedCustomFieldViewMutation,
    queryVariables,
  });
